import { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
import { Link } from "react-router-dom"

import './style.css'

// import Api from '../../../helpers/api';

// const api = new Api();

const COPHeader = () => {
    // let navigate = useNavigate()
    // const [collapseShow, setCollapseShow] = useState(false)
    // const [activeButton, setaAtiveButton] = useState('register')
    // const [user, setUser] = useState({})

    // useEffect(() => {
    //     setUser(JSON.parse(localStorage.getItem('user')))
    // }, [])

    // const toggleCollapse = () => {
    //     setCollapseShow(!collapseShow)
    // }

    // const clickButton = () => {
    //     setaAtiveButton(activeButton == 'login' ? 'register' : 'login')
    // }

    // const logout = () => {
    //     localStorage.clear()
    //     navigate('/thesis/login')
    // }

    return (
        <>
            <div className="card px-4" id="web-view" style={{ borderBottom: '1px solid #e9ecef', backgroundColor: '#fff' }}>
                <div className="row px-15 py-5">
                    <div className="col-md-6">
                        <Link to={'/'} className='color-orange fontweight-600'>
                            <img width={455} height={48} src={require('../../../assets/img/lpdp-talenta-cop.png')} alt="Logo LPDP Talenta CoP" />
                        </Link>
                    </div>
                </div>
            </div>

            <nav className="navbar navbar-expand-lg navbar-light bg-light bg-white" id="mobile-view" style={{ marginTop: '-5px' }}>
                <div className="container-fluid bg-white px-15" >
                    <Link to={'/'} className='navbar-brand cop'>
                        <img width={300} height={35} src={require('../../../assets/img/lpdp-talenta-cop.png')} alt="Logo LPDP Talenta CoP" />
                    </Link>
                </div>
            </nav>
        </>
    )
}

export default COPHeader